import React, { Component } from 'react';

class NavBarButton extends Component {
    render() {
        const { target, action, icon, iconColor } = this.props;
        return (
            <button className="navbar-toggler toggler-example secondmenu" 
                type="button" data-toggle="collapse"
                data-target="#navbarSupportedContent1"
                aria-controls="navbarSupportedContent1" 
                aria-expanded="false" 
                aria-label="Toggle navigation" 
                style={{color: iconColor}}
            >
                <span className="dark-blue-text">
                    <i className={icon} />
                </span>
            </button>
        );
    }
}

export default NavBarButton;